'use strict';

var _ = require('lodash');
var loadingIndicator = require('../../components/LoadingIndicator');
var TemplateConstants = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/TemplateConstants');
var ValidationRules = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/ValidationConstants').Rules;

exports.initialize = initialize;

var $paymentContainer = $('[payment-method="Workforce_Voucher"]');
var $paymentForm = $paymentContainer.find('form');
var $paymentMessage = $paymentContainer.find('.messages');
var $paymentErrorMessage = $paymentContainer.find('span.error');
var $paymentsApplied = $paymentContainer.find('.form-payments-applied');
var recaptcha;
var options = {};
var loaded = {};

function renderRecaptcha() {
	if (loaded.Recaptcha && options && options.Recaptcha && options.Recaptcha.EnabledForPaymentVouchers && options.Recaptcha.GoogleSiteKey) {
		recaptcha = grecaptcha.render('payment-voucher-apply-button', {
	        sitekey: options.Recaptcha.GoogleSiteKey,
	        callback: submitPaymentVoucher,
	        badge: 'bottomleft'
	    });
	}
}

function initialize(optionsParameter) {
	options = optionsParameter || {};

	renderRecaptcha();
	$(document).on('Recaptcha.Loaded', function(event) {
		if (!loaded.Recaptcha) {
			loaded.Recaptcha = true;
	        renderRecaptcha();
	    }
	});
	
    $paymentContainer.on('click', '.apply:not([loading]):not([disabled])', function (event) {
		event.preventDefault();

        if (!options || !options.Recaptcha || !options.Recaptcha.EnabledForPaymentVouchers || !options.Recaptcha.GoogleSiteKey) {
            $(document).trigger('WorkforceVoucher.Apply', event);
        }
	});
	
	$(document).on('WorkforceVoucher.Apply', function(event, data) {		
        event.preventDefault();
        var $this = $(data.target);
        var $voucher = $this.closest('[voucher-id');

        if (parseFloat($('[balance-due]').first().attr('balance-due')) <= 0) {
            $paymentErrorMessage.html(Resources.PaymentVoucher.NoBalanceDue).show();
            
            if (recaptcha != undefined) {
				grecaptcha.reset(recaptcha);
			}
        } else {
            $paymentErrorMessage.html('').hide();

            if (Urls.Workforce && Urls.Workforce.Vouchers && Urls.Workforce.Vouchers.PaymentPanel && Urls.Workforce.Vouchers.PaymentPanel.Apply) {
                $this.loading({
                    IsImageShown: true,
					IsLabelShown: false
                });

                $.ajax({
                    method: 'POST',
                    url: Urls.Workforce.Vouchers.PaymentPanel.Apply,
                    contentType: 'application/json',
                    data: JSON.stringify({
                        id: $voucher.attr('voucher-id')
                    }),
                    dataType: 'json',
                    success: function (data) {
                        $this.loading('destroy');
                        
                        if (data.success) {
                            if (data.amountApplied && data.amountApplied.value > 0) {
                            	$voucher.attr('is-applied', 'true');
                            }
                            
                            if (data.message) {
                            	$paymentErrorMessage.html(data.message).show();
                            }

                            $(document).trigger('Cart.Update');
                        } else {
                        	if (data.message == 'Invalid Message') {
                        		data.message = Resources.Error.Generic;	
                        	}
                        	
                            $paymentErrorMessage.html(data.message || Resources.Error.Generic).show();
                        }
                        
						if (recaptcha != undefined) {
							grecaptcha.reset(recaptcha);
						}
                    },
                    error: function() {
						$this.loading('destroy');
						$paymentErrorMessage.html(Resources.Error.Generic).show();
						
						if (recaptcha != undefined) {
							grecaptcha.reset(recaptcha);
						}
					}
                });
            } else {
            	if (recaptcha != undefined) {
					grecaptcha.reset(recaptcha);
				}	
            }
        }
    });

    $(document).off('mousedown.paymentPanel').on('mousedown.paymentPanel', function (event) {
        if ($(event.target).closest($paymentContainer).length == 0) {
            $paymentErrorMessage.html('').hide();
        }
    });

    $(document).on('CartData.Update', function (event, data) {
    	$('[has-gift-cards]').attr('has-gift-cards', data.HasGiftCards || false);
	    $('[has-gift-cards-only]').attr('has-gift-cards-only', data.HasGiftCardsOnly || false);
	    
	    if (data.HasGiftCards && !data.AllowpurchaseWithGiftCard) {
	    	$paymentMessage.html(Resources.GiftCard.purchaseWithGiftCardNotAllowed);
	    	$paymentContainer.attr('status', 'locked');
	    } else {
	    	$paymentMessage.html('');
	    	$paymentContainer.attr('status', 'active');
	    }
    });

    $paymentContainer.on('click', '.remove:not([loading])', function (event) {
        event.preventDefault();

        var $this = $(this);
        var $voucher = $this.closest('.workforce-voucher');
        $this.loading({
            IsImageShown: true,
            IsLabelShown: false
        });
        $paymentErrorMessage.html('').hide();

        $.ajax({
            url: Urls.Workforce.Vouchers.PaymentPanel.Remove,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                id: $voucher.attr('voucher-id')
            }),
            dataType : 'json',
            success : function(data) {
            	$this.loading('destroy');
            	
                if (data.success) {
                    $voucher.attr('is-applied', 'false');
                    $(document).trigger('Cart.Update');
                } else {
                	$paymentErrorMessage.html(data.error || Resources.Error.Generic).show();
                }
            },
            error: function() {
				$this.loading('destroy');
				$paymentErrorMessage.html(Resources.Error.Generic).show();
			}
        });
    });
}
